// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterPopover.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { PureComponent } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import FloatAffixed from 'share/components/controls/Izenda.FloatAffixed';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash/fp';
import GlimpseFilterProps from '../PropertiesBuilder/Izenda.GlimpseFilterProps';
import LoadingBar from 'share/components/controls/LazyLoading/Izenda.LazyLoadingBar';

const MIN_WIDTH = 500;

@connect()
export default class FilterPopover extends PureComponent {
  static propTypes = {
    anchor: PropTypes.object.isRequired,
    closePopover: PropTypes.func,
    store: PropTypes.object.isRequired,
    configField: PropTypes.object,
    showDeleteButton: PropTypes.bool,
    showSettingsButton: PropTypes.bool
  };

  constructor() {
    super();
    this.keepShowing = false;
  }

  /**
   * Open filter properties popup
   */
  openFilterPropertiesPopup = (e: Event) => {
    this.props.closePopover().then(() => this.props.openFilterPropertiesPopup(e));
  };

  /**
   * Render actions
   */
  renderActions() {
    const props = this.props;
    const { localization, showDeleteButton, showSettingsButton } = props;
    if (!showSettingsButton && !showDeleteButton)
      return null;
    return (
      <div className='izenda-FilterPopover-actions'>
        {showSettingsButton && (
          <a>
          <span
            className='icon-setting'
            title={localization.getText('COMMON_LABEL_EDIT')}
            onClick={this.openFilterPropertiesPopup}
          />
          </a>
        )}
        {showDeleteButton && (
          <a>
          <span
            className='icon-trash-empty'
            title={localization.getText('COMMON_LABEL_DELETE')}
            onClick={props.removeFilterItem}
          />
          </a>
        )}
      </div>
    );
  }

  /**
   * Render loading bar
   */
  renderLoading() {
    return (
      <div className='izenda-FilterPopover'>
        <LoadingBar />
      </div>
    );
  }

  /**
   * Keep showing or close popover
   * @param {boolean} doesKeep
   */
  updateKeepShowingHost = (doesKeep: boolean) => {
    this.keepShowing = doesKeep;
  };

  /**
   * Close popover
   */
  closePopover = () => {
    !this.keepShowing && this.props.closePopover();
  };

  /**
   * Render content
   */
  renderContent() {
    const { store } = this.props;
    return (
      <div className='izenda-FilterPopover'>
        <GlimpseFilterProps
          reportDesignerModel={store.masterModel}
          fieldStore={store}
          updateKeepShowingHost={this.updateKeepShowingHost}
          closePopover={this.props.closePopover}
        />
        {this.renderActions()}
      </div>
    );
  }

  render() {
    const { anchor, store } = this.props;
    const showLoading = !get('populatedData', store.reportFilters.configField);

    return (
      !isEmpty(anchor) && (
        <FloatAffixed onClickOutside={this.closePopover} anchor={anchor} minWidth={MIN_WIDTH} autoWidth>
          {showLoading ? this.renderLoading() : this.renderContent(store)}
        </FloatAffixed>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.FilterPopover.js